import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { ClientService } from "./client.service";
import { InspectionService } from "./inspection.service";
import { AppInstanceService } from "./app.instance.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private clientService: ClientService,
    private inspectionService: InspectionService,
    private router: Router,
    private appInstanceService: AppInstanceService,
  ) {}

  public async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    if (state.url.includes("/message")) {
      return true;
    }
    if (!this.appInstanceService.isActive) {
      await this.router.navigateByUrl(
        "message?content=This app is not designed for use with multiple tabs, this is done to preserve data integrity. &title=Multiple Tabs Not Allowed&subtitle=Please Close This Tab And Only Use A Singular Tab",
      );
      return false;
    }
    const isAuth = await this.authService.userIsAuthenticated();
    const hasCurrentClient = await this.clientService.hasCurrentClient();
    if (state.url.includes("/login") && isAuth) {
      await this.router.navigate(["/home"]);
      return true;
    }
    if (!state.url.includes("/login")) {
      if (!isAuth) {
        await this.router.navigate(["/login"]);
        return false;
      }
      if (!state.url.includes("/clients") && !hasCurrentClient) {
        await this.router.navigate(["/clients"]);
        return true;
      }
      if (state.url.includes("/clients") && hasCurrentClient) {
        await this.router.navigate(["/home"]);
        return true;
      }
      if (state.url.includes("/inspection") && hasCurrentClient) {
        const hasSelectedInspection =
          this.inspectionService.hasSelectedInspection();
        if (!hasSelectedInspection) {
          await this.router.navigate(["/home"]);
          return true;
        }
      }
      if (
        !state.url.includes("/inspection") &&
        !state.url.includes("/photo-editor") &&
        hasCurrentClient
      ) {
        await this.inspectionService.clearSelectedInspection();
      }
    }
    return true;
  }
}
